<fab-header [appName]="appName" navStyle="top">
  <button mat-button (click)="goHome()">Home</button>
  <button class="model-button" mat-button *ngIf="isModelNamePopulated()">{{modelName()}}</button>
</fab-header>
<div class="view-container">
  <router-outlet></router-outlet>
</div>
